export default [
	'first_natal',
	'aspect',
	'last_natal',
	'edit'
]